import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function ImpressumPage() {
  return <>
      <SEO title="Impressum" description="Impressum und rechtliche Informationen von CRMReview.de" canonicalUrl="/impressum" data-id="element-315" />

      <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-316">
        {/* Navigation */}
        <nav className="border-b border-slate-200 bg-white sticky top-0 z-50" data-id="element-317">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-318">
            <Link to="/" className="font-bold text-xl tracking-tight hover:opacity-80 transition-opacity" data-id="element-319">
              CRM<span className="text-blue-600" data-id="element-320">Review</span>
              <span className="text-slate-400 font-normal" data-id="element-321">.de</span>
            </Link>
          </div>
        </nav>

        <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-322">
          <h1 className="text-3xl font-bold mb-8" data-id="element-323">Impressum</h1>

          <div className="space-y-8 text-slate-700" data-id="element-324">
            <section data-id="element-325">
              <h2 className="text-xl font-bold text-slate-900 mb-4" data-id="element-326">Adresse</h2>
              <p data-id="element-327">
                CRM Kraft LLC
                <br data-id="element-328" />
                Vertreten durch: Justus Kraft
                <br data-id="element-329" />
                7901 4th St. N, Ste. 300
                <br data-id="element-330" />
                St. Petersburg, FL 33702
                <br data-id="element-331" />
                United States of America
              </p>
            </section>

            <section data-id="element-332">
              <h2 className="text-xl font-bold text-slate-900 mb-4" data-id="element-333">Kontakt</h2>
              <p data-id="element-334">
                Telefon: +49 157 35999071
                <br data-id="element-335" />
                E-Mail: justus@crm-kraft.de
              </p>
            </section>

            <section data-id="element-336">
              <h2 className="text-xl font-bold text-slate-900 mb-4" data-id="element-337">
                EU-Streitschlichtung
              </h2>
              <p data-id="element-338">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline ml-1" data-id="element-339">
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br data-id="element-340" />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section data-id="element-341">
              <h2 className="text-xl font-bold text-slate-900 mb-4" data-id="element-342">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              <p data-id="element-343">
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </main>

        <footer className="bg-slate-50 border-t border-slate-200 py-12 mt-12" data-id="element-344">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-slate-500 text-sm" data-id="element-345">
            <div className="flex justify-center space-x-6 mb-4" data-id="element-346">
              <Link to="/impressum" className="hover:text-slate-900" data-id="element-347">
                Impressum
              </Link>
              <Link to="/datenschutz" className="hover:text-slate-900" data-id="element-348">
                Datenschutz
              </Link>
            </div>
            <p data-id="element-349">
              © {new Date().getFullYear()} CRMReview.de - Alle Rechte
              vorbehalten.
            </p>
          </div>
        </footer>
      </div>
    </>;
}